var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpresa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_5408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 19.3818H6.88232V9.60128C6.88232 9.36635 6.98316 9.15615 7.17224 9.00777L13.3865 4.13606C13.8151 3.80221 14.4453 4.09896 14.4453 4.64301V19.3818Z",
    fill: "#52596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9622 19.3819H20.3697V12.3834C20.3697 12.2227 20.2941 12.0619 20.168 11.963L15.7185 8.47616C15.4159 8.24123 14.9622 8.45143 14.9622 8.83474V19.3819Z",
    fill: "#52596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6849 20.0001H6.31513C6.13866 20.0001 6 19.8641 6 19.691C6 19.5178 6.13866 19.3818 6.31513 19.3818H20.6849C20.8613 19.3818 21 19.5178 21 19.691C21 19.8641 20.8613 20.0001 20.6849 20.0001Z",
    fill: "#52596B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_5408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/empresa.003fcc9edadacedab99719efe0e73f34.svg";
export { ForwardRef as ReactComponent };